import {
  ArrowLeftIcon,
  ArrowUturnLeftIcon,
  EllipsisVerticalIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCommand, setMailMessageItemsLoad } from "../../redux/mailSlice";
import { getUserdetails } from "../../Localstorage/localstorage";
import ListChats from "../../Componenten/ListChats";
import { wa } from "./mailWaTheme";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const MailList = ({ setOpen, mobileChatOpen, onExitMobileChat }) => {
  const dispatch = useDispatch();
  const userdetails = getUserdetails();

  const { mailMessage, mailMessageItemsFilter, mailMessageItems } = useSelector(
    (state) => state.mail
  );

  useEffect(() => {
    const filterMessageItems = mailMessageItemsFilter.filter(
      (mail) => mail?.mailmessage_id === mailMessage?.id
    );
    dispatch(setMailMessageItemsLoad(filterMessageItems));
  }, [mailMessage, mailMessageItemsFilter, dispatch]);

  const openModal = (p_type = "insert") => {
    dispatch(setCommand(p_type));
    setOpen(true);
  };

  const subtitle =
    userdetails.role_id === 1
      ? mailMessage?.sender || "Geen patient"
      : mailMessage?.receiver || "Geen specialist";

  const title = mailMessage?.subject || "Berichten";

  return (
    <section
      aria-labelledby="message-heading"
      className={classNames(
        "flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden border-l",
        wa.border,
        wa.app,
        mobileChatOpen ? "flex" : "hidden md:flex"
      )}
    >
      <header
        className={classNames(
          "flex flex-shrink-0 items-center gap-2 border-b px-2 py-2 sm:px-3",
          wa.border,
          wa.panel2
        )}
      >
        <button
          type="button"
          onClick={onExitMobileChat}
          className={classNames(
            "rounded-full p-2 md:hidden",
            wa.muted,
            wa.hover,
            "hover:text-[#e9edef]"
          )}
          aria-label="Terug naar gesprekken"
        >
          <ArrowLeftIcon className="h-6 w-6" />
        </button>
        <div className="flex min-w-0 flex-1 items-center gap-3">
          <div
            className={classNames(
              "hidden h-10 w-10 flex-shrink-0 items-center justify-center rounded-full text-sm font-semibold sm:flex",
              wa.panel,
              wa.text
            )}
          >
            {(subtitle || "?").trim().slice(0, 1).toUpperCase()}
          </div>
          <div className="min-w-0 flex-1">
            <h1 id="message-heading" className={classNames("truncate text-base font-semibold", wa.text)}>
              {title}
            </h1>
            <p className={classNames("truncate text-xs", wa.muted)}>{subtitle}</p>
          </div>
        </div>
        <div className="flex flex-shrink-0 items-center gap-0.5">
          {mailMessage?.category ? (
            <span
              className={classNames(
                "mr-1 hidden max-w-[8rem] truncate rounded-full px-2 py-0.5 text-xs font-medium sm:inline",
                wa.panel,
                wa.muted
              )}
            >
              {mailMessage.category}
            </span>
          ) : null}
          <button
            type="button"
            className={classNames(
              "hidden rounded-full p-2 sm:inline-flex",
              wa.muted,
              wa.hover,
              "hover:text-[#e9edef]"
            )}
            aria-label="Zoeken in gesprek"
          >
            <MagnifyingGlassIcon className="h-5 w-5" />
          </button>
          {mailMessage ? (
            <button
              type="button"
              onClick={() => openModal("update")}
              title="Beantwoorden"
              className={classNames(
                "rounded-full p-2 transition-colors",
                wa.muted,
                wa.hover,
                "hover:text-[#e9edef]"
              )}
            >
              <ArrowUturnLeftIcon className="h-5 w-5" />
            </button>
          ) : null}
          <button
            type="button"
            className={classNames(
              "rounded-full p-2",
              wa.muted,
              wa.hover,
              "hover:text-[#e9edef]"
            )}
            aria-label="Meer"
          >
            <EllipsisVerticalIcon className="h-5 w-5" />
          </button>
        </div>
      </header>

      {!mailMessage ? (
        <div
          className={classNames(
            "flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center",
            wa.muted
          )}
        >
          <div className={classNames("rounded-full p-6", wa.panel)}>
            <ArrowUturnLeftIcon className="h-10 w-10 opacity-40" aria-hidden />
          </div>
          <p className="max-w-sm text-sm">
            Selecteer een gesprek in de lijst om berichten te bekijken, of start een nieuw gesprek.
          </p>
        </div>
      ) : (
        <div
          className="relative min-h-0 flex-1 overflow-hidden"
          style={{
            backgroundColor: "#0b141a",
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        >
          <div className="h-full min-h-0 overflow-y-auto">
            <ListChats chats={mailMessageItems} user={userdetails} />
          </div>
        </div>
      )}
    </section>
  );
};

export default MailList;
